module.exports = __webpack_public_path__ + "images/backgrounds/canyon/medium.976ada2d506ebb7c2f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/canyon/medium.jpg
// module id = bN6D
// module chunks = 1